document.addEventListener("DOMContentLoaded", () => {
  /* 3D 模块切换显示 */
  $(".modle-iconwrapper").click(function () {
    var module = $(".modle-views-container");

    if (module.css("display") == "none") {
      module.css("display", "block");
    } else {
      module.css("display", "none");
    }
  });
  /* 3D 模块切换显示 */




  /*  产品信息M端内容布局变化 (防止产品变体价格切换失效) */
  // var $productNavMb = $(".product-nav-mb-move");
  // var $productNavMbContent = $(".product-nav-mb-content");
  // var originalParent = $productNavMb.parent();

  // // 标记当前内容的位置
  // var isMoved = false;

  // // 定义处理函数
  // function handleResize() {
  //   var windowWidth = $(window).width();

  //   if (windowWidth < 1000 && !isMoved) {
  //     // 移动内容到 .product-nav-mb-content
  //     $productNavMbContent.append($productNavMb.contents());
  //     isMoved = true;
  //   } else if (windowWidth >= 1000 && isMoved) {
  //     // 将内容移回原始父容器
  //     originalParent.append($productNavMb.children());
  //     isMoved = false;
  //   }
  // }

  // // 初始检查
  // handleResize();

  // // 监听窗口大小变化
  // $(window).resize(function () {
  //   handleResize();
  // });

  /* 产品信息M端内容布局变化 */




  /* 促销折扣提示 */
  $(".product__info-wrapper").each(function () {
    if (
      $(this)
        .find(".metaobjects-sale_tips")
        .filter(function () {
          const dataIndex = $(this).attr("data-index");
          return dataIndex !== "1" && dataIndex !== "7";
        }).length > 0
    ) {
      $(this).find('.metaobjects-sale_tips[data-index="1"]').hide();
    }
  });
  /* 促销折扣提示 */



  // 插件加购弹窗侧边购物车
  setTimeout(function () {
    $(".tdf_normal_btn").click(function () {
      $("cart-drawer").addClass("active");
    });
  }, 2000);




  // 购物车跟新（排除 quick-add 弹窗内按钮，避免与 product-form 冲突）
  $(".product-form__submit").filter(function () {
    return $(this).closest("quick-add-modal").length === 0;
  }).click(function () {
    const addToCart = () => {
      return fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          items: [{ id: $('input[name="id"]').val(), quantity: 1 }],
        }),
      }).then((res) => {
        if (!res.ok) throw new Error("Failed to add product to cart.");
        return res.json();
      });
    };

    addToCart()
      .then(() => {
        return Promise.all([
          fetch(
            `${routes.cart_url}?section_id=cart-drawer&_=${Date.now()}`
          ).then((res) => res.text()),
          fetch(`${routes.cart_url}.js?_=${Date.now()}`).then((res) =>
            res.json()
          ),
        ]);
      })
      .then(([responseText, cartData]) => {
        // 更新 cart-drawer 内容
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const targetElement = document.querySelector("cart-drawer");
        const sourceElement = html.querySelector("cart-drawer");
        if (targetElement && sourceElement) {
          targetElement.innerHTML = sourceElement.innerHTML;
          targetElement.classList.add("active");
          targetElement.classList.remove("is-empty");
        }

        // 更新购物车图标计数
        const cartItemCount = cartData.item_count;
        let cartCountBubble = document.querySelector(
          "#cart-icon-bubble .cart-count-bubble"
        );
        if (!cartCountBubble) {
          cartCountBubble = document.createElement("div");
          cartCountBubble.className = "cart-count-bubble";
          cartCountBubble.innerHTML = `<span aria-hidden="true">${cartItemCount}</span><span class="visually-hidden">${cartItemCount} item</span>`;
          document
            .querySelector("#cart-icon-bubble")
            .appendChild(cartCountBubble);
        } else {
          cartCountBubble.querySelector(
            'span[aria-hidden="true"]'
          ).textContent = cartItemCount;
          cartCountBubble.querySelector(
            ".visually-hidden"
          ).textContent = `${cartItemCount} item`;
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });


  });
  // 购物车跟新



  if (typeof window.initOpenBoxPurchase === 'function') {
    window.initOpenBoxPurchase(document);
  }

});
